import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Space, Spin, Col } from "antd";
import OTPInput from "otp-input-react";
import { useTranslation } from "react-i18next";
import { postRequest } from "../axios";
import { SuccessNotificationMsg } from "../utils/Notifications";
import { loadingIcon } from "../utils/Helper";
import Mail from "../image/mail.png";
import { ReactComponent as GreenWp } from "../image/greenwp.svg";
import PropTypes from "prop-types";
const VerifyBankOtpModal = ({
  visible,
  handleCancel,
  VendorId,
  OTP,
  setOTP,
  state,
  setState,
  seconds,
  setSeconds,
  minutes,
  setMinutes,

  setVerificationResultEmail,
  setVerifyEmailButtonView,
  checkVerificationDone,
  setCheckVerificationDone,
  setCheckFormValueChange,
  handleSubmitVendor,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const otpInputRef = useRef(null);
  const [apiLoading, setApiLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const initialState = {
    phone_number: state.phone_number ? state.phone_number : null,
    phone_number_otp: OTP,
  };

  const [verifyState, setVerifyState] = useState(initialState);

  // const state = {
  //   phone: type === "phone" || type === "whatsapp" ? atob(id) : null,
  //   email: type === "email" ? atob(id) : null,
  //   otp: Number(OTP),
  // };

  // const resendState = {
  //   otp_method: type === "phone" || type === "whatsapp" ? "phone" : "email",
  //   whatsapp_verified: type === "whatsapp" ? true : false,
  //   phone: type === "phone" || type === "whatsapp" ? atob(id) : null,
  //   email: type === "email" ? atob(id) : null,
  // };
  useEffect(() => {
    if (otpInputRef.current) {
      otpInputRef.current.focusInput(0); // Focus the first OTP input box
    }
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(30);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const handleSubmit = async () => {
    console.log("VendorIdSubmit", VendorId);
    try {
      setBtnLoading(true);
      const apiResponse = await postRequest(
        `vendor-bank-detail/phone-number-otp-verifed/?vendor_id=${VendorId}`,
        verifyState
      );
      console.log("apiiiiiiii", apiResponse);
      if (apiResponse.data.success) {
        setCheckVerificationDone(true);
        setCheckFormValueChange(false);
        setVerificationResultEmail("success");
        setVerifyEmailButtonView(false);

        setState((prevState) => ({
          ...prevState,
          phone_verified: true,
        }));
        setVerifyState(initialState);

        SuccessNotificationMsg("Verified Successfully");
        handleSubmitVendor();
        handleCancel();
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        phone_verified: false,
      }));
      setCheckVerificationDone(false);
      setVerificationResultEmail("");
      handleCancel();
      setVerifyEmailButtonView(true);
    } finally {
      setBtnLoading(false);
      // setVerificationResultEmail('');
    }
  };
  const handleOtpChange = (value) => {
    setOTP(value);
    setVerifyState((prevState) => ({
      ...prevState,
      phone_number: state.phone_number ? state.phone_number : null,
      phone_number_otp: value,
    }));
  };
  const handelResendClick = async () => {
    setOTP(null);

    try {
      setApiLoading(true);
      console.log("VendorId", VendorId);
      const apiResponse = await postRequest(
        `vendor-bank-detail/resend-otp/?vendor_id=${VendorId}`,
        {
          phone_number: state.phone_number ? state.phone_number : null,
        }
      );
      if (apiResponse.data.success) {
        SuccessNotificationMsg("OTP resent successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setApiLoading(false);
    }
  };

  return (
    // <Modal
    //   visible={true}
    //   title={mode === "email" ? "Email OTP Verification" : "WhatsApp OTP Verification"}
    //   onCancel={handleCancel}
    //   footer={null}
    // >
    <Spin spinning={apiLoading} indicator={loadingIcon}>
      <Form onFinish={handleSubmit} ref={formRef}>
        <label>OTP has been sent on {state.phone_number}</label>

        <div className="modelotp">
          <div className="Otp-Input-Box">
            <OTPInput
              ref={otpInputRef}
              value={OTP}
              onChange={(value) => handleOtpChange(value)}
              autoFocus
              OTPLength={4}
              otpType="number"
              disabled={false}
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={btnLoading}
            className="GradiantBtn mt-2"
          >
            {t("verify")}
          </Button>

          <Col className="VerifyOTP-Options mt-2">
            <Space>
              {seconds > 0 || minutes > 0 ? (
                <p style={{ margin: 0 }}>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p style={{ margin: 0 }}>{t("didnotreceived")}</p>
              )}
              <Button
                type="link"
                onClick={handelResendClick}
                loading={apiLoading}
                style={{
                  color: seconds > 0 || minutes > 0 ? "GrayText" : "#094E8F",
                }}
                disabled={seconds > 0 || minutes > 0}
                danger
              >
                {t("resendOTP")}
              </Button>
            </Space>
          </Col>
        </div>
      </Form>
    </Spin>
    // </Modal>
  );
};

VerifyBankOtpModal.propTypes = {
  id: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  OTP: PropTypes.func.isRequired,
  setOTP: PropTypes.func.isRequired,
  onClose: PropTypes.number,
  VendorId: PropTypes.number,
  visible: PropTypes.bool,
  state: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  setMinutes: PropTypes.func.isRequired,
  setSeconds: PropTypes.func.isRequired,
  seconds: PropTypes.func.isRequired,
  minutes: PropTypes.func.isRequired,
  handleSubmitVendor: PropTypes.func.isRequired,
  checkVerificationDone: PropTypes.func.isRequired,
  setCheckVerificationDone: PropTypes.func.isRequired,
  setCheckFormValueChange: PropTypes.func.isRequired,

  setVerificationResultEmail: PropTypes.func.isRequired,
  setVerifyEmailButtonView: PropTypes.func.isRequired,
};
export default VerifyBankOtpModal;
